import React, { useState } from 'react';
import S from './StatusSensor.module.scss';

interface StatusSensorProps {
  sensorId?: string | number;
  status?: number; // 0-10: 0=off, 1=on, 2-10=autres modes
  color?: string; // Couleur personnalisée du mode (basevie)
  modeName?: string; // Nom du mode
}

const StatusSensor: React.FC<StatusSensorProps> = ({ 
  sensorId = '1', 
  status = 1,
  color,
  modeName
}) => {
  const [showPopup, setShowPopup] = useState(false);
  
  // Pour l'instant, état en dur
  const currentStatus = 1; // 0=off, 1=on, 2-10=autres modes
  const lastStatusDate = new Date(); // Date en dur pour demo

  const getStatusLabel = (status: number): string => {
    if (modeName) return modeName;
    if (status === 0) return 'OFF';
    if (status === 1) return 'ON';
    return `Mode ${status}`;
  };

  const getStatusClass = (status: number): string => {
    // Si on a une couleur personnalisée, on n'utilise pas les classes par défaut
    if (color) return '';
    if (status === 0) return S.statusOff;
    if (status === 1) return S.statusOn;
    return S.statusMode;
  };
  
  const getCustomStyle = () => {
    if (!color) return {};
    return {
      background: `linear-gradient(135deg, ${color} 0%, ${adjustBrightness(color, -15)} 100%)`,
      border: `1px solid ${adjustBrightness(color, -20)}`,
      color: 'white'
    };
  };
  
  // Fonction pour assombrir une couleur
  const adjustBrightness = (color: string, percent: number): string => {
    const num = parseInt(color.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = (num >> 8 & 0x00FF) + amt;
    const B = (num & 0x0000FF) + amt;
    return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
      (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
      (B < 255 ? B < 1 ? 0 : B : 255))
      .toString(16).slice(1);
  };

  const formatDate = (date: Date): string => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <span 
      className={S.statusTicketWrapper}
      onMouseEnter={() => setShowPopup(true)}
      onMouseLeave={() => setShowPopup(false)}
    >
      <span 
        className={`${S.statusTicket} ${getStatusClass(currentStatus)}`}
        style={getCustomStyle()}
      >
        <span className={S.statusText}>{getStatusLabel(currentStatus)}</span>
      </span>
      
      {showPopup && (
        <span className={S.statusPopup}>
          <div className={S.popupHeader}>
               <div className={S.popupRow}>
              <span className={S.popupLabel}>Statut:</span>
              <span className={`${S.popupValue} ${getStatusClass(currentStatus)}`}>
                {getStatusLabel(currentStatus)}
              </span>
            </div>
          </div>
          <div className={S.popupContent}>
            <div className={S.popupRow}>
              <span className={S.popupLabel}>Dernier signal:</span>
              <span className={S.popupValue}>{formatDate(lastStatusDate)}</span>
            </div>
          </div>
          <div className={S.popupArrow}></div>
        </span>
      )}
    </span>
  );
};

export default StatusSensor;
